
import superagent from "superagent";
import { handleLoading } from "../app/actions";
import { authorize, authorize_onboarding } from "../helper/authorize-token";
import { CookieWrap as Cookies } from "../helper/cookie-wrap";
import { ONBOARDING_TOKEN_LABEL } from "../../lib/token";
import {deep_copy, deep_update} from "../../lib/js-utils";
import { sprintf } from "sprintf-js";
import { deep_assign } from "../../lib/js-utils";

const CLEAR_ONBOARDING_DATA = "CLEAR_ONBOARDING_DATA";
const DATA_TO_STORE = "DATA_TO_STORE";
const CLEAR_ONBOARDING_TOKEN = "CLEAR_ONBOARDING_TOKEN";
const DATA_TO_DYNAMO = "DATA_TO_DYNAMO";
const LOAD_ONBOARDING_DATA = "LOAD_ONBOARDING_DATA";
const CLEAR_ONBOARDING_ITEM = "CLEAR_ONBOARDING_ITEM";
const CLEAR_ONBOARDING_ITEM_LOCAL = "CLEAR_ONBOARDING_ITEM_LOCAL";
const SET_ONBOARDING_DATA = 'SET_ONBOARDING_DATA';
const ONBOARDING_SET_LOADING = "ONBOARDING_SET_LOADING";

const signNewEnvelope = (
  token, onboarding_token, index, onboarding_data, return_url, signing_type, username) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/docuSign/sign-new-envelope")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ onboarding_data, return_url, index, signing_type, username })
       .then(result => {
        resolve(result.body.payload);
      });
  })
};

const getHypKeys = (token, onbooarding_token, hyp_version) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/onboarding/get-hyperverge-keys")
      .send({ stage: hyp_version })
      .use(authorize_onboarding(token, onbooarding_token))
      .then(result => {
        resolve(result.body.data);
      })
  })
}

const getHypFakeData = (token, onboarding_token) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/onboarding/get-hyperverge-fake-data")
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        resolve(result.body.data);
      })
  })
}

const signSetUserInfo = (token, onboarding_token, index, username) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/docuSign/sign-set-user-info")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ username, index })
      .then(() => {
        return resolve();
      });
  });
}

const signEnvelope = (token, onboarding_token, index, signer, return_url) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/docuSign/sign_envelope")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ return_url, index, signer })
      .then(result => {
        resolve(result.body.data.url);
      });
  });
};

const createUser = (
  wlf_id, email, first_name, last_name, phone_number, do_kyc,
  request_args) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/create_user")
      .send({
        wlf_id, email, first_name, last_name, phone_number,
        do_kyc, request_args })
      .then(result => {
        resolve(result.body.data);
      })
  })
};

const addAccount = (token, onboarding_token) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/add-account")
      .use(authorize_onboarding(token, onboarding_token))
      .then(res => {
        resolve(res.body.data);
      })
  });
}

const clearOnboardingData = () => {
  const cookies = new Cookies();
  cookies.remove(ONBOARDING_TOKEN_LABEL, { path: '/' });
  return dispatch => {
    dispatch({
      type: CLEAR_ONBOARDING_DATA,
    });
  }
};

const dataToStore = (data, index, username) => {
  return dispatch => {
    dispatch({
      type: DATA_TO_STORE,
      data: data,
      index: index,
      username,
    });
  }
};

const setOnboardingData = (onboarding, index, username) => {
  return dispatch => {
    dispatch({
      type: SET_ONBOARDING_DATA,
      data: onboarding,
      index,
      username,
    })
  }
};

const loadOnboardingData = (index, username) => {
  return (dispatch, getState) => {
    dispatch({
      type: ONBOARDING_SET_LOADING,
      loading: true,
    })
    dispatch({
      type: LOAD_ONBOARDING_DATA,
      payload: superagent
        .post("/api/onboarding/load-onboarding-data")
        .send({index, username})
        .use(authorize_onboarding(
          getState().user.token,
          getState().user.onboarding_token))
        .send({}),
    });
  }
};

const loadOnboardingDataSA = (token, username, wlf_id, index) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/load-onboarding-data")
      .use(authorize(token))
      .send({ username, wlf_id, index })
      .then(res => {
        resolve(res.body.data);
      })
  });
};

const goLive = (token, onboarding_token, index) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/go-live")
      .use(authorize_onboarding(token, onboarding_token))
      .send({index})
      .then(res => {
        resolve(res.body.data);
      })
  })
}

const adminGoLive = (token, index, username) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/admin-go-live")
      .use(authorize(token))
      .send({index, username})
      .then(res => {
        resolve(res.body.data);
      })
  })
}

/**
 * @param prefix: {string}
 * @param fields: {[
 *   { data: string, filename: string }
 * ]}
 * @param encoding {string} utf-8|base64|...
 */
const UploadTextBlobs = (token, onboarding_token, encoding, prefix, fields, index, username) => {

  const form_data = new FormData();
  fields.forEach(field => {
    form_data.append("text_blob[]", field.data);
    form_data.append("file_name[]", field.filename);
  });
  form_data.append("prefix", prefix);
  form_data.append("index", index);
  form_data.append("encoding", encoding);
  if (username) {
    form_data.append("username", username);
  }

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/upload-text-blobs")
      .use(authorize_onboarding(token, onboarding_token))
      .send(form_data)
      .then(res => {
        return resolve(res.body.data);
      })
  })

}

const UploadFile = (token, onboarding_token, file, prefix, index, username) => {
  const form_data = new FormData();
  form_data.append("file", file);
  form_data.append("prefix", prefix);
  form_data.append("index", index);
  if (username) {
    form_data.append("username", username);
  }

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/upload")
      .use(authorize_onboarding(token, onboarding_token))
      .send(form_data)
      .then(res => {
        return resolve(res.body.data);
      })
  });
};

const DeleteUploadFile = (token, onboarding_token, prefix, index, file_index) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/delete-upload-file")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ prefix, index, file_index})
      .then(res => {
        return resolve(res.body.data);
      })
  })
}

const clearOnboardingItem = (index, clear_prm_names, username) => {
  return (dispatch, getState) => {
    dispatch({
      type: CLEAR_ONBOARDING_ITEM_LOCAL,
      index,
      clear_prm_names,
      username,
    })
    dispatch({
      type: CLEAR_ONBOARDING_ITEM,
      payload: superagent
        .post("/api/onboarding/clear-onboarding-item")
        .use(authorize_onboarding(
          getState().user.token,
          getState().user.onboarding_token))
        .send({ clear_prm_names, index, username })
    })
  }
};

const dataToDynamo = (data, index, done, disable, username, identity_id) => {
  return (dispatch, getState) => {
    dispatch({
      type: DATA_TO_DYNAMO,
      payload: superagent
        .post("/api/onboarding/new_data")
        .use(handleLoading(dispatch, disable))
        .use(authorize_onboarding(
          getState().user.token, getState().user.onboarding_token))
        .send({
          username,
          identity_id,
          index: index,
          data: data,})
        .then(() => {
          if (done) {
            done();
          }
        })
    });
  }
};

const sendConfirmationEmail = (token, onboarding_token, index, set_live_state) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/send-confirmation-email")
      .send({index, set_live_state})
      .use(authorize_onboarding(token, onboarding_token))
      .then(resolve);
  });
};

const adminSendConfirmationEmail = (token, index, set_live_state, username) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/admin-send-confirmation-email")
      .send({index, set_live_state, username})
      .use(authorize(token))
      .then(resolve);
  });
};

const calcCategoryAllocation = (token, onboarding_token, index, username, identity_id) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/calc-category-allocation")
      .send({ index, username, identity_id })
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        resolve(result.body.data);
      });
  })
}

const onboardingReducer = (state = {}, action) => {
  let result, index, username, onboarding;

  switch(action.type) {
    case CLEAR_ONBOARDING_DATA:
      return {};
    case CLEAR_ONBOARDING_TOKEN + "_FULFILLED":
      return { };

    case LOAD_ONBOARDING_DATA + "_FULFILLED":
      index = sprintf("%04d", action.payload.body.data.index);
      username = action.payload.body.data.username;
      onboarding = action.payload.body.data.onboarding;
      result = deep_copy(state);
      if (username) {
        deep_assign(result, [username, index], onboarding);
      } else {
        deep_assign(result, [index], onboarding);
      }
      deep_update(result, [], { loading: false });
      return result;

    case SET_ONBOARDING_DATA:
      index = sprintf("%04d", action.index);
      result = deep_copy(state);
      if (action.username) {
        deep_assign(result, [action.username, index], action.data);
      } else {
        result[index] = action.data;
      }

      return result;

    case CLEAR_ONBOARDING_ITEM_LOCAL:
      result = deep_copy(state);
      index = sprintf("%04d", action.index);
      username = action.username;
      action.clear_prm_names.forEach(prop => {
        if (username) {
          delete result[username][index][prop];
        } else {
          delete result[index][prop];
        }
      })
      return result;

    case CLEAR_ONBOARDING_ITEM + "_FULFILLED":
      index = sprintf("%04d", action.payload.body.data.index);
      username = action.payload.body.data.username;
      onboarding = action.payload.body.data.onboarding;
      result = deep_copy(state);
      result.loading = false;
      if (username) {
        deep_assign(result, [username, index], onboarding);
      } else {
        deep_assign(result, [index], onboarding);
      }
      return result;

    case ONBOARDING_SET_LOADING:
      const new_state = deep_copy(state);
      new_state.loading = action.loading;
      deep_update(new_state, [], { loading: action.loading});
      return new_state;

    case DATA_TO_STORE:
      result = deep_copy(state);
      if (action.index === -1) {
        // replace the entire thing
        Object.assign(result, action.data);
      } else if (action.username) {
        const key = sprintf("%04d", action.index);
        deep_update(result, [action.username, key], action.data);
      } else {
        const key = sprintf("%04d", action.index);
        if (!(key in result)) {
          result[key] = {};
        }
        Object.assign(result[key], action.data);
      }

      return result;
    default:
      return state;
  }
};

const signingDone = (token, onboarding_token, index) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/onboarding/signing_done")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ index })
      .then(resolve);
  });
};

export { onboardingReducer, clearOnboardingData, dataToStore,
  dataToDynamo, sendConfirmationEmail, adminSendConfirmationEmail,
  createUser, signNewEnvelope, signEnvelope,
  DATA_TO_STORE, loadOnboardingData,
  clearOnboardingItem, signingDone,
  UploadFile, addAccount, setOnboardingData,
  loadOnboardingDataSA, goLive, adminGoLive, DeleteUploadFile,
  calcCategoryAllocation, signSetUserInfo,
  getHypKeys, getHypFakeData, UploadTextBlobs,
};